import { Bot, CircleX, Plus } from 'lucide-react';

import { cn } from '@/lib/utils';
import { Button } from '@/modules/ui/components/button/Button';
import { Heading } from '@/modules/ui/components/heading/Heading';

interface CopilotHeaderProps {
  isChatActive: boolean;
  onNewSession: () => void;
  onClose?: () => void;
}

export const CopilotHeader = ({
  isChatActive,
  onNewSession,
  onClose,
}: CopilotHeaderProps) => {
  return (
    <div
      className={cn(
        'flex items-center justify-between rounded-t-lg px-6 py-8',
        isChatActive && 'bg-secondary-150',
      )}
    >
      <CopilotHeaderTitle />

      <div className="flex items-center">
        <Button
          variant="icon"
          size="icon"
          className="text-primary"
          onClick={onNewSession}
          title="New session"
        >
          <Plus />
        </Button>

        {onClose && (
          <Button
            variant="icon"
            size="icon"
            className="text-primary"
            onClick={onClose}
            title="Close"
          >
            <CircleX />
          </Button>
        )}
      </div>
    </div>
  );
};

const CopilotHeaderTitle = () => {
  return (
    <div className="flex items-center gap-2">
      <Bot size={24} className="text-primary-600" />
      <Heading variant="h3" className="text-primary-600">
        Finny
      </Heading>
    </div>
  );
};
